export default __webpack_public_path__ + "static/media/pantry1-afterF-2048w.334a6c10.webp";